import { ELIGIBILITY_DETERMINED } from '../actions/storeEligibilityStatus';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case ELIGIBILITY_DETERMINED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
